import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import heic2any from 'heic2any';


@Component({
  selector: 'app-lab-reports',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lab-reports.component.html',
  styleUrl: './lab-reports.component.css'
})
export class LabReportsComponent {
  @Input() reports:any;
  modalPdfUrl: SafeResourceUrl | null = null;
  modalImageUrl: SafeUrl | null = null;
  isImage:boolean = false;
  isLoadingPreview:boolean = false;
  private previewObjectUrl: string | null = null;

  constructor(private sanitizer: DomSanitizer) {
   
  }

  private cleanupPreviewObjectUrl() {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
      this.previewObjectUrl = null;
    }
  }

  closePreview() {
    this.cleanupPreviewObjectUrl();
    this.modalPdfUrl = null;
    this.modalImageUrl = null;
    this.isLoadingPreview = false;
    this.isImage = false;
  }

 async viewReport(doc: any) {
    const url = String(doc ?? '');
    const lower = url.toLowerCase();

    this.cleanupPreviewObjectUrl();
    this.modalPdfUrl = null;
    this.modalImageUrl = null;
    this.isLoadingPreview = true;

    const isPdf = lower.endsWith('.pdf');
    const isHeic = lower.endsWith('.heic') || lower.endsWith('.heif');
    const isStandardImage =
      lower.endsWith('.jpeg') ||
      lower.endsWith('.jpg') ||
      lower.endsWith('.png') ||
      lower.endsWith('.gif') ||
      lower.endsWith('.webp');

    try {
      if (isPdf) {
        this.isImage = false;
        this.modalPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        return;
      }

      // Browsers generally cannot render HEIC/HEIF directly; convert to JPEG for preview.
      if (isHeic) {
        this.isImage = true;
        const res = await fetch(url, { cache: 'no-store' });
        const blob = await res.blob();
        const converted = await heic2any({ blob, toType: 'image/jpeg', quality: 0.9 });
        const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
        this.previewObjectUrl = URL.createObjectURL(jpegBlob as Blob);
        this.modalImageUrl = this.sanitizer.bypassSecurityTrustUrl(this.previewObjectUrl);
        return;
      }

      if (isStandardImage) {
        this.isImage = true;
        this.modalImageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
        return;
      }

      // Fallback: try iframe (covers pdf-like URLs without extension).
      this.isImage = false;
      this.modalPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } finally {
      this.isLoadingPreview = false;
    }
  }
 
downloadReport(doc: any,name:any) {
if(doc.includes('.pdf')){
  const a = document.createElement('a');
  a.href = doc;
  a.target = '_blank';
  a.download = name; 
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a); 
}else{
  const printWindow = window.open('', '_blank');
  if (printWindow) {
  const img = new Image();
      img.src = doc;
      img.onload = () => {
        printWindow.document.write(`
          <html>
            <head>
              <title>Report</title>
              <style>
                body {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100vh;
                  margin: 0;
                  background: white;
                }
                img {
                  max-width: 100%;
                  height: auto;
                }
              </style>
            </head>
            <body>
              <img src="${doc}">
            </body>
          </html>
        `);
        // printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };

      img.onerror = () => {
        console.log(doc);
        console.error('Image failed to load.');
      };
    }else{
      console.log('Please allow popups for this website');
    }
  }
}
}
